import { TimePicker, TimeRangePickerProps } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import React from "react";
import styled from "styled-components";

dayjs.extend(customParseFormat);

const StyleTimePicker = styled(TimePicker.RangePicker)`
  :where(.css-dev-only-do-not-override-naxx1s).ant-picker {
    height: 45px;
  }
`;

export const CRangeTimePicker: React.FC<TimeRangePickerProps> = ({
  className,
  ...props
}) => {
  const format = "HH:mm";
  return (
    <StyleTimePicker
      className={`w-full ${className}`}
      {...props}
      format={format}
      getPopupContainer={(e) => e}
    />
  );
};
